import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const STORAGE_KEY = 'mdg.sidebarCollapsed';

/**
 * The shell every signed-in page renders inside. The collapsed state persists
 * so the layout does not reset on each navigation or reload.
 */
export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(collapsed));
    } catch {
      // A browser with storage disabled still works, it just does not remember.
    }
  }, [collapsed]);

  return (
    <div className="app-shell">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((v) => !v)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      {mobileOpen && (
        <div className="sidebar-scrim" onClick={() => setMobileOpen(false)} aria-hidden="true" />
      )}

      <main className="app-main">
        <Outlet context={{ onOpenMobileNav: () => setMobileOpen(true) }} />
      </main>
    </div>
  );
}
